import { getCliniqueWebsiteForImageUrl } from './utilitaries';

export const getSkinDiagShopNowUrl = (
	sppURL: string | undefined,
	market: string,
	isMicrosite: boolean,
	retailer: unknown,
): string | null => {
	if (isMicrosite || retailer || !['US', 'NA', 'UK'].includes(market) || !sppURL?.trim()) return null;

	try {
		const website = getCliniqueWebsiteForImageUrl(market);
		const productUrl = new URL(sppURL, website);
		if (!['https:', 'http:'].includes(productUrl.protocol)) return null;
		return new URL(productUrl.pathname + productUrl.search + productUrl.hash, website).toString();
	} catch {
		return null;
	}
};
